var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedal = function SvgMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#medal_svg__a)",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.873 11.81 22 20l-4-1-2 3-3.275-7.037M6.127 11.81 2 20l4-1 2 3 3.275-7.037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
    fill: "#7D89FF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#fff",
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "medal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMedal;